/** Mantis logo — bundled by webpack so it always loads in dev and production. */
import logoSmall from '../assets/logo_small.png';

export default logoSmall;
